/**
 * `<load-more>` custom element (feature list v1.2, infinite scroll).
 *
 * Progressive enhancement over the classic pagination: without JavaScript
 * the default pagination inside [data-load-more-fallback] does the job.
 * With it, the button appears, the fallback hides, and the next page's
 * cards are fetched via the Section Rendering API and appended to the
 * grid — automatically too, when the button scrolls into view.
 */
class LoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more-button]');
    const fallback = this.querySelector('[data-load-more-fallback]');
    if (fallback) fallback.hidden = true;
    if (!this.button) return;

    this.button.hidden = false;
    this.loading = false;
    this.button.addEventListener('click', () => this.load());

    new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load();
    }).observe(this.button);
  }

  load() {
    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl || this.loading) return;
    this.loading = true;
    this.button.disabled = true;

    const separator = nextUrl.includes('?') ? '&' : '?';
    fetch(`${nextUrl}${separator}section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-collection-grid]');
        const grid = this.closest('.collection').querySelector('[data-collection-grid]');
        if (newGrid && grid) {
          while (newGrid.firstChild) grid.appendChild(newGrid.firstChild);
        }
        const newLoadMore = doc.querySelector('load-more');
        const newNext = newLoadMore ? newLoadMore.dataset.nextUrl : null;
        if (newNext) {
          this.dataset.nextUrl = newNext;
          this.button.disabled = false;
        } else {
          delete this.dataset.nextUrl;
          this.button.hidden = true;
        }
      })
      .catch(() => {
        this.button.disabled = false;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}

if (!customElements.get('load-more')) {
  customElements.define('load-more', LoadMore);
}
